import styled from "../../styled";
import { themeLss } from "../../lss";
export var Box = styled.div(themeLss());
export var Flex = styled(Box)({
  display: 'flex'
});